<path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.9606"
    d="M2.13867 12.2281H22.1021m-6.2982-6.99983 7 7.00003-7 7"
/>
